import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyDbjVt5sF9iVpGPngygCzWXqrUbN-ihpjg",
  authDomain: "pace-affairs-ecommerce.firebaseapp.com",
  projectId: "pace-affairs-ecommerce",
  storageBucket: "pace-affairs-ecommerce.firebasestorage.app",
  messagingSenderId: "157946273534",
  appId: "1:157946273534:web:1f00cfb5effbe578568faf"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
// 🔥 CREATE SERVICES
const db = getFirestore(app);
const auth = getAuth(app);

// 🔥 EXPORT THEM PROPERLY
export { db, auth };